import { Pager } from "./dtos";

export interface DataTableFilter {
    filterBy: string,
    filterValue: string,
}

export function createEmptyFilter(): DataTableFilter {
    return {
        filterBy: "",
        filterValue: "",
    };
}

export interface DataTableOrderBy {
    orderBy: string,
    orderDirection: string,
}

export function createEmptyOrderBy(): DataTableOrderBy {
    return {
        orderBy: "",
        orderDirection: "asc",
    };
}

export const PagingDefaults: number[] = [5, 10, 25, 50, 100];

export function getPaginatorOptions(pager: Pager, includeTotal: boolean = true) : number[] {
    const baseOptions: number[] = PagingDefaults;
    const rowsPerPageOptions = baseOptions
        .filter(size => size <= pager.totalRows)
        .concat(includeTotal ? pager.totalRows : []);
    return rowsPerPageOptions;
}

export function getPaginatorLayout(pager: Pager) : string {
    const baseOptions: number[] = PagingDefaults;
    const showPageSizeDropdown = pager.totalRows > Math.min(...baseOptions);
    const isSinglePage = pager.totalRows <= pager.pageSize; 
    const paginatorLayout = showPageSizeDropdown
        ? (isSinglePage 
            ? "RowsPerPageDropdown CurrentPageReport"
            : "RowsPerPageDropdown FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport")
        : "CurrentPageReport";
    return paginatorLayout;
}